import { Component } from "react";
import { makeBEM } from "../global/utils";
import { LABELS, POST_LOGIN_RELOAD_DELAY } from '../global/constants';
import userManager from "./user-manager";
import LoginForm from "../forms/LoginForm";
import { ReactComponent as Logo} from '../logo.svg';

class UserLoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        
        this.moduleName = 'user-login-form';
        this.loginSuccess = this.loginSuccess.bind(this);
    }

    loginSuccess(result) {
        if ( result.user ) {
            const userData = result.user;
            userManager.login(userData);

            setTimeout(() => {
                window.location.reload();
            }, POST_LOGIN_RELOAD_DELAY);
        }
    }

    render() {
        return (
            <div className={ this.moduleName }>
                <div className={ makeBEM(this.moduleName, "wrapper") } >
                    <div className={ makeBEM(this.moduleName, "logo-wrapper") }>
                        <Logo className="logo"/>
                    </div>
                    <h1 className={ makeBEM(this.moduleName, "header") } >{ LABELS.appName }</h1>
                    { <LoginForm 
                        // moduleName={this.moduleName}
                        loginSuccess={this.loginSuccess} /> }
                </div>
            </div>
        );
    }
}

export default UserLoginForm;